import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch } from "react-redux";
import Icons from "../../../assets/js/Icons";

import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";

const WebnarCreate = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideDialog());
  };

  return (
    <Paper>
      <DialogTitle sx={{ position: "relative" }}>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "black",
            position: "absolute",
            bgcolor: "#0000001f !important",
          }}
          size="small"
          onClick={handleClose}
          LinkComponent={Link}
          to={"/specialist/profile/webinars/all"}
        >
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Box sx={{ mb: 1, display: "grid", placeContent: "center" }}>
          <Icon
            sx={{
              fontSize: "100px",
              color: "primary.main",
              svg: { display: "block" },
            }}
          >
            <Icons.SentPlane />
          </Icon>
        </Box>
        <Typography
          fontSize={15}
          color="other.color1"
          textAlign="center"
        ></Typography>
        <Typography
          mt={2}
          fontSize={14}
          color="other.color1"
          textAlign="center"
        >
          Thank you! Your webinar is under review. You’ll be notified upon
          approval.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          color="primary"
          variant="contained"
          sx={{
            minWidth: "150px",
            justifyContent: "center",
          }}
          onClick={handleClose}
          LinkComponent={Link}
          to={"/specialist/profile/webinars/all"}
        >
          Okay
        </Button>
      </DialogActions>
    </Paper>
  );
};

export default WebnarCreate;
